import { Box, Typography } from "@material-ui/core";
import { useI18nContext } from "@hopper-b2b/i18n";
import "./styles.scss";
import clsx from "clsx";

interface ITravelersSummary {
  travelers: string;
  className?: string;
  label?: string;
}

export const TravelersSummary = ({
  travelers,
  className,
  label,
}: ITravelersSummary) => {
  const { t } = useI18nContext();
  return (
    <Box className={clsx("travelers-summary-container", className)}>
      <Typography variant="body2" className="travelers-text">
        {label || t("travelerSummaryLabel")}
      </Typography>
      <Typography variant="subtitle2" className="traveler-names">
        {travelers}
      </Typography>
    </Box>
  );
};
